import type { CookiesContentModal } from "./types";

export const deTranslations: CookiesContentModal = {
    title: "COOKIES",
    content:
        "Wir nutzen Cookies und andere Technologien.",
    closeButton: "Schließen",
    accceptAllButton: "ALLES AKZEPTIEREN",
    rejectButton: "ABLEHNEN",
        sections: [
        {
            title: "",
            content: [
                "Diese Seite nutzt einwilligungsbedürftige Cookies und Technologien von Drittunternehmen zur Integration bestimmter Funktionen. Es werden essenzielle, funktionale, Performance- und Tracking-Cookies verwendet. Wenn Sie hier einwilligen, werden diese Funktionen aktiviert. Nach der Einwilligung verarbeiten wir und die betroffenen Drittunternehmen Ihre personenbezogenen Daten für verschiedene Zwecke. Sie können Ihre Einwilligung jederzeit widerrufen oder Ihre Cookie-Einstellungen in Ihrem Webbrowser anpassen. Detaillierte Informationen zu Zweck, Rechtsgrundlagen, Drittunternehmen können Sie unserer Datenschutzerklärung entnehmen.",
            ],
        }
    ],
    tableBox: {
        title: "",
        tableHead: [],
        tableData: [],
        content: ""
    }
};
